import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {UtilsService} from "../../services/utils.service";
import {OrderSummary} from "../../services/event-registration.service";

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss']
})
export class OrderSummaryComponent implements OnChanges {

  @Input() orderSummary: OrderSummary;

  public total: number;

  constructor() { }

  ngOnChanges(): void {
    if(this.orderSummary) {
      this.total = UtilsService.priceSum([this.orderSummary.price, this.orderSummary.commission])
    }
  }

}
